import { Reducer } from 'redux'
import { IGlnLocatiesPerVestigingState } from '../interfaces'
import {
  GlnLocatiesPerVestigingActions,
  Actions,
} from '../actions/glnLocatiesPerVestigingAction'

const initialState: IGlnLocatiesPerVestigingState = {
  loading: false,
  vestiging: undefined,
  locaties: [],
  foutmelding: undefined,
}

export const glnLocatiesPerVestigingReducer: Reducer<
  IGlnLocatiesPerVestigingState,
  GlnLocatiesPerVestigingActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetDataRequest:
      return { ...state, loading: true, locaties: [], foutmelding: null }
    case Actions.GetDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        locaties: action.success ? action.payload : [],
      }

    case Actions.ClearDataRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.ClearDataResponse:
      return {
        ...state,
        loading: false,
        locaties: [],
        foutmelding: action.success ? action.payload : action.errorMessage,
      }

    case Actions.SetWarehouseAction:
      return { ...state, locaties: [], vestiging: action.payload }

    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
